import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { salesAdapter, salesApiSlice as api } from 'services/api/sales';
import { SocketMessage } from 'services/api/types';
import getSocket from '.';
import { WS_ROS_ACTIVE_CHANGED, WS_ROS_VERSION_GENERATED } from 'constants/actionTypes';
import uploadVehicleApi from 'services/api/upload-vehicle';

export const useSellerGlobalSocketHandler = () => {
  const user = useSelector((state: any) => state.user?.user);
  const dispatch = useDispatch() as ThunkDispatch<any, any, AnyAction>;
  const { page, perPage, filters } = useSelector((state: any) => state.mySales);

  const paginationRef = useRef({ page, perPage, filters });
  paginationRef.current = { page, perPage, filters };

  const listener = ({ type, payload }: SocketMessage) => {
    if (type === WS_ROS_VERSION_GENERATED && payload.report_type === 'seller') {
      const vehicleId: number = payload.vehicle_id;

      dispatch(
        uploadVehicleApi.util.updateQueryData('getVehicleById', vehicleId, draft => {
          (draft as any).seller_report_of_sale = payload.url;
        })
      );

      const { page: p, perPage: pp, filters: f } = paginationRef.current;
      dispatch(
        api.util.updateQueryData('getMySales', { limit: pp, offset: p, ...f }, draft => {
          salesAdapter.updateOne(draft.rows, {
            id: vehicleId,
            changes: { seller_report_of_sale: payload.url },
          });
        })
      );
    }

    if (type === WS_ROS_ACTIVE_CHANGED && payload.report_type === 'seller') {
      const vehicleId: number = payload.vehicle_id;

      dispatch(
        uploadVehicleApi.util.updateQueryData('getVehicleById', vehicleId, draft => {
          (draft as any).seller_report_of_sale = payload.url;
        })
      );

      const { page: p, perPage: pp, filters: f } = paginationRef.current;
      dispatch(
        api.util.updateQueryData('getMySales', { limit: pp, offset: p, ...f }, draft => {
          salesAdapter.updateOne(draft.rows, {
            id: vehicleId,
            changes: { seller_report_of_sale: payload.url },
          });
        })
      );
    }
  };

  useEffect(() => {
    if (!user || user.role !== 'seller') return;

    const socket = getSocket();
    socket.emit('subscribe', { prefix: `user`, ids: [user.id] });
    socket.on('message', listener);

    return () => {
      socket.emit('unsubscribe', { prefix: `user`, ids: [user.id] });
      socket.off('message', listener);
    };
  }, [dispatch, user?.id, user?.role]);
};
